import React from 'react';

const AvatarImgSquarePlaceholder = (props: any) => (
  <svg width="123" height="122" viewBox="0 0 123 122" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect
      x="1.5"
      y="1"
      width="120"
      height="120"
      rx="8"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="8 8"
    />
    <path
      d="M73.5 58.3333V67.6667C73.5 70.6122 71.1122 73 68.1667 73H54.8333C51.8878 73 49.5 70.6122 49.5 67.6667V54.3333C49.5 51.3878 51.8878 49 54.8333 49H62.8333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M49.5 62.3335L51.2269 60.6066C51.8297 60.0037 52.6474 59.665 53.5 59.665C54.3526 59.665 55.1702 60.0037 55.7731 60.6066L61.5 66.3335"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M54.8372 73.0001L63.2308 64.6066C64.4862 63.3512 66.5216 63.3512 67.777 64.6066L73.0292 69.8588"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M69.5 49L66.1667 52.3333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M72.8333 52.3333L69.5 49" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M69.5 49V55.6667" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default AvatarImgSquarePlaceholder;
